import FallbackHeaderImageSource from '../../../assets/illustrations/defaultSplash.png';
import { SlideImage } from './slide/SlideImage';

interface CarouselSlideBackgroundProps {
    children?: React.ReactNode;
    src?: string;
}

export function CarouselSlideBackground({ children, src }: CarouselSlideBackgroundProps) {
    return (
        <SlideImage
            addLoading
            src={src ?? FallbackHeaderImageSource}
            style={{
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: -1,
                height: '100%',
            }}
        >
            {children}
        </SlideImage>
    )
}
